// extracted by mini-css-extract-plugin
export default {"addButtonContainer":"createNewTeamButton_addButtonContainer__gtN4L","addButton":"createNewTeamButton_addButton__QSbJ4"};